/**
 * Scroll-spy pick: given each block's top offset relative to the scroll
 * container (0 = at the container's top edge, positive = below it) in DOM
 * order, return the anchor of the block currently occupying the top region —
 * the last block whose top has scrolled at/above `threshold`. Blocks are in
 * document order (tops ascending), so the first block past the line ends it.
 * Falls back to the first block (top of page) when nothing has crossed yet.
 */
export function pickActiveAnchor(
  blocks: ReadonlyArray<{ anchor: string; top: number }>,
  threshold: number,
): string | null {
  if (blocks.length === 0) return null;
  let active = blocks[0]!.anchor;
  for (const b of blocks) {
    if (b.top <= threshold) active = b.anchor;
    else break;
  }
  return active;
}
